import React, { Component } from 'react';
import { ShellSidebarPanel } from 'web-ui-components/lib/layout/content';
import { Content } from '../infrastructure/content';
import { ProgressStepper } from 'web-ui-components/lib/navigation/indicators';

class StepHeader extends Component {
  render() {
    const { completedStep = false, currentStep } = this.props;

    return (
      <Content>
        {({ progressItemA, progressItemB, progressItemC }) => (
          <ShellSidebarPanel>
            <ProgressStepper
              isComplete={completedStep}
              currentStepId={currentStep}
              items={[
                {
                  id: '1',
                  titleText: progressItemA
                },
                {
                  id: '2',
                  titleText: progressItemB
                },
                {
                  id: '3',
                  titleText: progressItemC
                }
              ]}
            />
          </ShellSidebarPanel>
        )}
      </Content>
    );
  }
}

export default StepHeader;
